import { atom } from "jotai";

type Position = {
  x: number;
  y: number;
  z: number;
};

export type FloorplanLayer = {
  id: string;
  name: string; // ground floor, f
  position: Position;
  imageUrl: string | undefined;
  width:number;
  height:number
  opacity: number;
  isBase:boolean;
  // rotation to be added
  // scale to be added
};
export const floorPlanLayerSelected = atom<any>();

export const floorplanLayersAtom = atom<FloorplanLayer[]>([]);

export const newFloorModalOpenAtom = atom<boolean>(false);
